import React from 'react';
import './css/Eventfeed3.css'

export const Eventfeed3 = (props) => {

    return (
        <div className="padN" >
            <div className="eventTitleN"> {props.title}</div>
            <div className="sidecontainer2N">
                <div className="eventimageN" >
                    {(props.picture.length === 7 &&
                        <img alt="placeholder" className="breezeHolderN" src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} />) || (
                            <img alt="uploaded" className="theImagesN" src={props.picture} />)}
                </div>
                <hr className="dividerN" />
                <div className="EventDetailsContainer">
                    <div className="timeContainer">
                        <div className="time">
                            <b className="bold">Start</b>
                            {props.start}
                        </div>
                        <div className="time">
                            <b className="bold">End</b>
                            {props.end}
                        </div>
                    </div>
                    <div className="location">
                        <b className="bold">Location: </b>
                        {props.location}
                    </div>
                </div>
            </div>
        </div>
    );
}